import styled, { keyframes } from "styled-components";

import { ReactComponent as SpinnerIcon } from "@/assets/icons/color-spinner.svg";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled(SpinnerIcon)`
  animation: ${spin} 1s linear infinite;
`;

const ToastSpinner = () => {
  return <Spinner />;
};

export default ToastSpinner;
